jQuery(document).ready(function($) {

  function filterFunction() {
    const filter = $("#tenants-filter");
    $.ajax({
      url: filter.attr('action'),
      data: filter.serialize(),
      type: filter.attr('method'),
      success: function(data){
        $('#featured-tenants__tenants').html(data);
      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.log("Request failed: " + textStatus + " " + errorThrown);
      }
    });
  };
  $("#tenants-filter").on("input", filterFunction);

});
